import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import WalletConnectWalletInfo from '../WalletInfo/WalletConnectWalletInfo';
import { extractAddress } from '../helper';
import { useAccount } from 'wagmi';
import { useDisconnect } from "@reown/appkit/react";
import { TRON_PLATFORM_TYPE } from '../../../../Constants/MainKeys';

export default function WalletConnectWalletConfig({
  allBalance,
  selectedChain,
  selectedToken,
  setAddress,
}) {
  // Early return if Tron network is selected - this component should not render for Tron
  if (selectedChain?.platformType === TRON_PLATFORM_TYPE) {
    return null;
  }

  const { disconnect } = useDisconnect();
  const { address } = useAccount();

  useEffect(() => {
    if (address) {
      setAddress(address);
    }
  }, [address])

  const _disconnect = async () => {
    await disconnect();
    setAddress("");
  }

  return (
    <div>
      <div className="title-block">
        <strong >
          {
            address ? `Wallet address ${extractAddress(address)}` : " Connect your wallet & Pay"
          }
        </strong>
      </div>
      <div className='mt-3'>
        <div className="p-3 text-dark">
          {
            !address ?
              <div>
                <p className='mb-4 wallet-info-text'>
                  You have selected a network and token for this transaction. To continue, click the <b>Pay</b> button below.
                  Once you proceed, you will be prompted to securely connect your wallet via WalletConnect. This step ensures a safe and encrypted connection between your wallet and the application.
                  <br /><br />
                  After your wallet is successfully connected, the payment process will start automatically. Please review the transaction details in your wallet and confirm it to complete the payment.
                  <br /><br />
                  Make sure your wallet has sufficient balance and is connected to the correct network before proceeding.
                </p>
                {/* <Button variant="primary w-100 shadow" onClick={() => setIsShowModal(true)}>Connect Wallet</Button> */}
                {/* <appkit-button /> */}
              </div> :
              <div>
                {/* <w3m-button balance loadingLabel /> */}
                <WalletConnectWalletInfo
                  allBalance={allBalance}
                  selectedChain={selectedChain}
                  selectedToken={selectedToken}
                />
                <div className="d-flex justify-content-end mt-3">
                  <Button size='sm' variant="danger" onClick={_disconnect}>Disconnect Wallet</Button>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}

